import Component from 'vue-class-component';
import EdCreateCourseMaterialObject from '@/courses/components/course-material-object/ed-create-course-material-object/ed-create-course-material-object.vue';
import { IParamsCreateCourseMaterialObject } from '@/courses/interfaces/params-create-course-material-object.interface';
import { IParamsCourseObject } from '@/courses/interfaces/params-course-object.interface';
import { Mixins, Prop } from 'vue-property-decorator';
import KEYS from '@/values/keys';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { SECTION_TYPES } from '@/content/values/sections';
import Course from '@/content/models/course.model'
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';

@Component({
  name: 'ed-course-create-course-material-object',
  components: {
    EdCreateCourseMaterialObject
  }
})
export default class EdCourseCreateCourseMaterialObject extends Mixins(CreateObjectsMixin) {

  // @Prop() readonly params: IParamsCourseObject; //Typescript upgrade
  declare readonly params: IParamsCourseObject;
  
  public createMaterialParams: IParamsCreateCourseMaterialObject;

  get course(): Course {
    return this.getCourseFromStore({courseId: this.params.courseId});
  }

  get sectionMaterialId() {
    if(this.params.edition) {
      this.params.section.sectionMaterial.id;
    } else {
      return null;
    }
  }

  get section() {
    return this.params.section;
  }

  get sectionId() {
    return this.params.section.sectionId;
  }

  get parentId() {
    return this.params.parentId;
  }

  get spinner(): any {
    return this.$refs.EdCreateForm;
  }

  onSaveCmo(data: any) {
    if(this.params.edition) {
      if(this.params.section.hasBeenResolvedByAnyStudent && this.shouldArchiveCurrentHomeworks(data) ) {
        this.$EdModal.createConfirmationModal(
          {
            body: this.$i18n.t('courses.objects.confirmEdit'),
            action: async () => {
              this.updateCmo(data);
            }
          }
        );
      } else {
        this.updateCmo(data);
      }
    } else {
      this.saveCmo(data);
    }
  }

  shouldArchiveCurrentHomeworks(data: any){
    if(data.material.relatedContentId == this.params.section.sectionMaterial.materialId &&
       data.end ==  this.params.section.sectionMaterial.endSection &&
       data.start ==  this.params.section.sectionMaterial.startSection){
      return false;
    }
    return true;
  }

  async saveCmo(data: any) {
    let dueDate = this.getSchoolDayIndex(data.dueDate);
    let lastDate = this.getSchoolDayIndex(data.lastDate);
    let payload = {
      ...data, 
      dueDate: dueDate ? dueDate : '', 
      lastDate: lastDate ? lastDate : '',
      parentId: this.parentId, 
      type: SECTION_TYPES.LESSON_MATERIAL.code,
      courseId:  this.params.courseId,
      submissionDates: {
        dueSchoolDay: this.getSchoolDayIndex(data.dueDate),
        dueDate: data.dueDate,
        lastSchoolDay: this.getSchoolDayIndex(data.lastDate),
        lastDate: data.lastDate
      },
      labelSections: data.labelSections,
    };
    let sectionMaterial = {
      materialId: data.material.relatedContentId,
      sectionId: this.parentId,
      startSection: data.all ? 1 : encodeURIComponent(data.start),
      startSectionLabel: data.all ? null : encodeURIComponent(data.startLabel),
      endSectionLabel: data.all ? null : encodeURIComponent(data.endLabel),
      endSection: data.all ? null : encodeURIComponent(data.end),
      displayType: data.displayType
    };
    if((data.material.data.subtype == KEYS.FILES_TYPE.EPUB) && data.all) {
      sectionMaterial.startSection = 'all';
    }
    payload.sectionMaterial = JSON.stringify(sectionMaterial);
    this.spinner.setSaving(true);
    this.$Courses.Store.createSectionFromObjectA(payload)
    .then(async (res) => {
      let data = {sectionId: res.id, parentId: this.parentId , 
      courseId: this.params.courseId , classId: this.params.classId };
      await this.goToRefreshSectionsTree(data);
      this.$EdModal.closeModal();
    }).catch((error) => {
      this.triggerErrorModal(error.data || error);
    }).finally(() => {
      this.spinner.setSaving(false);
    });
  }

   updateCmo(data: any) {
    let dueDate = this.getSchoolDayIndex(data.dueDate);
    let lastDate = this.getSchoolDayIndex(data.lastDate);
    let sectionMaterial = {
      id: this.params.section.sectionMaterial.id,
      materialId: data.material.relatedContentId,
      sectionId: this.sectionId,
      startSection: data.all ? 1 : encodeURIComponent(data.start),
      startSectionLabel: encodeURIComponent(data.startLabel),
      endSectionLabel: encodeURIComponent(data.endLabel),
      sectionName: data.name,
      endSection : data.all ? '' : encodeURIComponent(data.end),
      displayType: data.displayType,
      homework: data.homework, 
      homeworkPoints : data.homeworkPoints || 0,
      homeworkWeight : data.homeworkWeight || 0,
      teacherOnly: data.material.data.teacherOnly,
      dueSchoolDay: dueDate ? dueDate : '',
      lastSchoolDay: lastDate ? lastDate : '',
      submissionDates: {
        dueSchoolDay: this.getSchoolDayIndex(data.dueDate),
        dueDate: data.dueDate,
        lastSchoolDay: this.getSchoolDayIndex(data.lastDate),
        lastDate: data.lastDate,
        ...this.dueDateInfo
      },
      ...this.dueDateInfo,
      labelSections: data.labelSections,
    };
    if((data.material.data.subtype == KEYS.FILES_TYPE.EPUB) && data.all){
      sectionMaterial.startSection = 'all';
    }
    let payload = { ...sectionMaterial, courseId: this.params.courseId };
    this.spinner.setSaving(true);
    this.$Courses.Store.updateSectionMaterialA(payload)
    .then(() => {
      let section = SectionsProvider.getSectionByID(this.course.sections, this.sectionId);
      section.name = data.name;
      section.homework = data.homework;
      section.homeworkPoints = data.homeworkPoints;
      section.homeworkWeight = data.homeworkWeight;
      section.teacherOnly = data.material.data.teacherOnly;
      this.$Courses.Store.updateSection(section as any);
      this.getContentForCourse({courseId: this.params.courseId, classId:this.params.classId})
      .finally(
        ()=>{ 
          this.spinner.setSaving(false);
          this.$EdModal.closeModal();
          this.goToSectionPreview({sectionId: this.sectionId , courseId: this.params.courseId,
            classId: this.params.classId});
        }
      );
    }).catch((error) => {
      this.triggerErrorModal(error.data || error);
    }).finally(() => {
      this.spinner.setSaving(false);
      this.$edEventBus.$emit(COURSES_EVENTS.RENDER_COMPONENT);
    });
  }

  getCurrentMaterial() {
    if(this.params.edition) {
      return SectionsProvider.findCurrentCourseMaterial(
        this.course.materials,
        this.params.section.sectionMaterial.materialId
      );
    } else {
      return null;
    }
  }

  created() {
    let displayType = this.params.edition ? this.params.section.sectionMaterial.displayType : '';
    let start = this.params.edition ? decodeURIComponent(this.params.section.sectionMaterial.startSection) : '';
    let end = this.params.edition ? decodeURIComponent(this.params.section.sectionMaterial.endSection) : '';
    let name = this.params.edition ? this.params.section.name : '';
    let homework = this.params.edition ? this.params.section.homework : false;
    let homeworkPoints = this.params.edition ?  this.params.section.homeworkPoints : 100;
    let homeworkWeight = this.params.edition ?  this.params.section.homeworkWeight : 1;
    let hasBeenResolvedByAnyStudent = this.params.edition ? this.params.section.hasBeenResolvedByAnyStudent : false;
    let dates = this.params.section ? this.params.section.submissionDates || {} : {};
    this.createMaterialParams = {
      name,
      hasTitle: true,
      hasButtons: true,
      hasName: true,
      edition: this.params.edition,
      currentMaterial: this.getCurrentMaterial(),
      homework,
      homeworkPoints,
      homeworkWeight,
      hasBeenResolvedByAnyStudent,
      displayType,
      start,
      end,
      dueDate: this.getSchoolDayDate(dates.dueSchoolDay),
      lastDate: this.getSchoolDayDate(dates.lastSchoolDay),
      courseId: this.params.courseId,
      classId: this.params.classId,
      minDate: this.params.minDate,
      submissionDates: this.params.section ? this.params.section.submissionDates : {},
      hasTagSelector: this.params.contentType === 'TEMPLATE',
      labelSections: this.params.section?.labelSections,
    };
  }

}